import gql from "graphql-tag";

export default gql`
  query GetCompanyAssets($id: ID!) {
    allAssets(filter: { company: { id: $id } }) {
      id
      name
      model
      description
      category
      barcode
      site {
        id
        name
      }
      primaryUser {
        id
        firstName
        lastName
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/GraphQL/Queries/GetCompanyAssets.ts